export { useGenerateServicePlugin } from './ServicePlugin.js';
